import React from 'react';

import FormGroupWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/FormGroupWrapper';
import CustomDropdown from '@/components/CustomDropdown';
import InputField from '@/components/InputField';
import InputWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/InputWrapper';
import { formatSampleTypeOptions } from '@/features/sampleDevelopment/utils';
// import { REQUEST_FOR_SAMPLE_SECTION } from '@/features/sampleDevelopment/constants';

const SendToSampleSectionForm = ({
	handleChange,
	requestValues,
	errors,
	sampleTypeList = [],
	isReviseSample
}) => {
	const updatedSampleTypeList = sampleTypeList?.filter((item) => item?.constant !== 'REVISE');
	return (
		<React.Fragment>
			<div className="flied-item d-grid grid-columns-2 gap-3">
				<InputWrapper labelTitle="Required date*">
					<InputField
						type="date"
						name="requiredDate"
						value={requestValues?.requiredDate}
						onChangeHandler={(e) => handleChange('requiredDate', e.target.value)}
						withWrapper={false}
						withLabel={false}
						errors={errors?.requiredDate}
					/>
				</InputWrapper>

				{/* <FormGroupWrapper labelTitle="Request for*">
					<CustomDropdown
						title="Select request for"
						onItemClick={(value) => handleChange('requestFor', value)}
						selectedItem={requestValues?.requestFor?.value}
						items={REQUEST_FOR_SAMPLE_SECTION}
					/>
					{errors?.requestFor && <p className="error">{errors?.requestFor}</p>}
				</FormGroupWrapper> */}

				<FormGroupWrapper labelTitle="Sample Type">
					<CustomDropdown
						isDisabled={isReviseSample}
						title="Select sample type"
						onItemClick={(value) => handleChange('sampleType', value)}
						selectedItem={isReviseSample ? 'Revise' : requestValues?.sampleType?.value}
						items={formatSampleTypeOptions(updatedSampleTypeList)}
					/>
					{errors?.sampleType && <p className="error">{errors?.sampleType}</p>}
				</FormGroupWrapper>
			</div>
		</React.Fragment>
	);
};

export default SendToSampleSectionForm;
